export default function Group(props) {
    const { id, name, description, imageSrc, online } = props.data;

    const handleClick = () => {
        if (props.conversation.id !== id) {
            props.openConversation(props.data);
        }
    }

    return (
        <li className="user-list-item d-flex" onClick={handleClick}>
            <div className="avatar">
                <img className="rounded-circle" src={imageSrc} alt={name} height={48} width={48} />
            </div>
            <div className="users-list-body d-flex flex-grow-1">
                <div className="d-flex flex-column flex-grow-1">
                    <h5>
                        {name}
                    </h5>
                    <p>
                        { online ? online : description }
                    </p>
                </div>
            </div>
        </li>
    );
}
